module.exports = __webpack_public_path__ + "static/media/ever_pano_02-min.e06bce5f.JPG";